import { render } from "./FpApp.vue?vue&type=template&id=5a8ee484&lang=pug"
import script from "./FpApp.vue?vue&type=script&lang=js"
export * from "./FpApp.vue?vue&type=script&lang=js"

import "./FpApp.vue?vue&type=style&index=0&id=5a8ee484&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__